import React from 'react';

const Carousel = () => {
	return (
		<div style={{ marginBottom: 100 }}>
			<div
				id='carouselExampleIndicators'
				class='carousel slide'
				data-ride='carousel'>
				<ol class='carousel-indicators'>
					<li
						data-target='#carouselExampleIndicators'
						data-slide-to='0'
						class='active'></li>
					<li data-target='#carouselExampleIndicators' data-slide-to='1'></li>
					<li data-target='#carouselExampleIndicators' data-slide-to='2'></li>
				</ol>
				<div class='carousel-inner'>
					<div class='carousel-item active'>
						<img
							class='d-block w-100'
							src='https://gallery.veenaworld.com/homePageCms/banner/desktop/ewjHRhz8LJDkOR-M2ghWT_20-02-2023_094502.jpg?imwidth=1920&impolicy=nowatermark'
							alt='First slide'
						/>
					</div>
					<div class='carousel-item'>
						<img
							class='d-block w-100'
							src='https://gallery.veenaworld.com/homePageCms/banner/desktop/ewjHRhz8LJDkOR-M2ghWT_20-02-2023_094502.jpg?imwidth=1920&impolicy=nowatermark'
							alt='Second slide'
						/>
					</div>
					<div class='carousel-item'>
						<img
							class='d-block w-100'
							src='https://gallery.veenaworld.com/homePageCms/banner/desktop/ewjHRhz8LJDkOR-M2ghWT_20-02-2023_094502.jpg?imwidth=1920&impolicy=nowatermark'
							alt='Third slide'
						/>
					</div>
				</div>
				<a
					class='carousel-control-prev'
					href='#carouselExampleIndicators'
					role='button'
					data-slide='prev'>
					<span class='carousel-control-prev-icon' aria-hidden='true'></span>
					<span class='sr-only'>Previous</span>
				</a>
				<a
					class='carousel-control-next'
					href='#carouselExampleIndicators'
					role='button'
					data-slide='next'>
					<span class='carousel-control-next-icon' aria-hidden='true'></span>
					<span class='sr-only'>Next</span>
				</a>
			</div>
		</div>
	);
};

export default Carousel;
